export default __webpack_public_path__ + "static/media/triceps_push-ups_end.23972544.svg";